// extracted by mini-css-extract-plugin
export default {"row":"Tlb5qzdo4iC_cH9Wo2pP","title":"TckJchxsH0XoCAYALx6D"};